import React from 'react';
import PropTypes from 'prop-types';
import StyledTitle from '../../hoc/StyledTitle';

@StyledTitle
class Img extends React.Component {

  static propTypes = {
    children: PropTypes.any
  }

  render() {
    const { children, ...props } = this.props;
    return (
      <img name="Img" {...props}>{children}</img>
    );
  }

}

export default Img;
